// src/utils/permessiEffettivi.js
// ═══════════════════════════════════════════════════════════════════════════
// PERMESSI EFFETTIVI DI UNA PERSONA (ottobre 2026, W417 — regole 65)
// ═══════════════════════════════════════════════════════════════════════════
// Un solo posto per la regola «ruolo + aggiunte − rimozioni» (prima ripetuta in useCanSee,
// Sidebar, avvisiFatturazione e Abilitazioni), identica a haSezione() delle Regole Firestore.
//
// Permessi nati DOPO il salvataggio delle Abilitazioni: una scelta salvata vale solo per i
// permessi che esistevano quando è stata fatta. Gli altri partono dal loro default di ruolo
// (es. «Sopralluoghi senza commessa» → Project Manager sì), finché l'Admin non decide.
//  • dal salvataggio W417 in poi il documento porta «sezioniNote»: l'elenco dei permessi
//    esistenti in quel momento;
//  • documenti salvati prima: un permesso è «già visto» se è spuntato per almeno un ruolo;
//    se non lo è per nessuno, è nato dopo e vale il default.
// Le scelte per singola persona (utenti / utentiRimossi) valgono sempre.
// ═══════════════════════════════════════════════════════════════════════════
import { PERMESSI_DEFAULT_PER_RUOLO } from "./permessiDefaultPerRuolo";

/** I ruoli operativi, nello stesso ordine delle Regole (sezioneGiaVista). */
export const RUOLI_PERMESSI = ["gestione", "amministrazione", "pm", "magazziniere", "operativi"];

const lista = (v) => (Array.isArray(v) ? v : []);

/** Il permesso esisteva quando le Abilitazioni sono state salvate? */
export function sezioneNota(ab, sez) {
  if (Array.isArray(ab?.sezioniNote)) return ab.sezioniNote.includes(sez);
  return RUOLI_PERMESSI.some(r => lista(ab?.ruoli?.[r]).includes(sez));
}

/** Default di un ruolo (sezioni). */
export const defaultDelRuolo = (ruolo) => lista(PERMESSI_DEFAULT_PER_RUOLO[ruolo]?.sezioni);

/**
 * Le sezioni di un ruolo: quelle salvate, più i default dei permessi nati dopo il salvataggio.
 * Ruolo mai salvato → i suoi default.
 */
export function sezioniDelRuolo(ab, ruolo) {
  const salvato = ab?.ruoli && Object.prototype.hasOwnProperty.call(ab.ruoli, ruolo);
  if (!salvato) return new Set(defaultDelRuolo(ruolo));
  const out = new Set(lista(ab.ruoli[ruolo]));
  defaultDelRuolo(ruolo).forEach(s => { if (!sezioneNota(ab, s)) out.add(s); });
  return out;
}

/** Le sezioni effettive di una persona: ruolo + aggiunte − rimozioni. */
export function sezioniUtente(ab, { ruolo, uid } = {}) {
  const r = ruolo || "operativi"; // il più restrittivo, se non ancora assegnato
  const out = sezioniDelRuolo(ab || {}, r);
  lista(ab?.utenti?.[uid]).forEach(s => out.add(s));
  lista(ab?.utentiRimossi?.[uid]).forEach(s => out.delete(s));
  return out;
}
